if (typeof window.CustomProductRecommendations === 'undefined') {
  function addToCart(form) {
    document.getElementById('popup-product-details').innerHTML =
      '<div class="add-bag-overlay__loader"><div class="add-bag-detail-loader"></div> </div>';
    const variantId = form.querySelector('input[name="id"]').value;
    const items = [
      {
        id: variantId,
        quantity: 1
      }
    ];
    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({items})
    })
      .then(data => {
        return data.json();
      })
      .then(json => {
        if(!json.status){
          theme.sideCart.updateCartItemsEvent();
          window.theme.sideCart.refreshCart();
          if (window.theme.settings.enable_bopis) {
            openCartPopup();
            let size;
            if(json.items[0].options_with_values && json.items[0].options_with_values.length){
              let sizeOption = json.items[0].options_with_values.find(option => option.name.toLowerCase() === 'size');
              if(sizeOption){
                size = sizeOption.value;
              }
            }
            updateCartPopup({
              title: json.items[0].product_title,
              image: json.items[0].image,
              quantity: 1,
              size:size,
              vId: variantId
            });
          } else {
            theme.sideCart.openDrawer();
          }
        }
      })
      .catch(err => console.error(err));
  }
  window.CustomProductRecommendations = class CustomProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.waitOnReady();
      //let moneyFormat = window.Currency.moneyFormats[window.Shopify.currency.active].money_format || null;
      //moneyFormat = moneyFormat.replace(window.theme.currentCurrencySymbol,'');
      //this.moneyFormat = moneyFormat;
    }
    // Element functionality written in here
    waitOnReady() {
      if( this.shadowRoot && window.xgenCss ) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = window.xgenCss;
        this.shadowRoot.appendChild(link);
      }
      if (this.shadowRoot && this.shadowRoot.querySelector('form[action*="cart/add"] input[name="id"]')) {
        setTimeout(() => {
          this.onReady();
        }, 0);
      } else {
        setTimeout(() => {
          this.waitOnReady();
        }, 1000);
      }
    }
    formatMoney(price) {
      //return Currency.formatMoney(currentVariant.price, this.moneyFormat)
      window.theme.moneyFormat = window.theme.moneyFormat.replace(' MYR', '')
      const originalText = Currency.formatMoney(price, window.theme.moneyFormat)
      const ShopifyCurrencyMoneyFormat =  window.theme.moneyFormat;
      const baseCurrencySymbol = window.theme.currencySymbol;
      const regx = '\\' +  baseCurrencySymbol + '\\s*\\d+([.,]\\d+)?';

      if( !originalText.includes(baseCurrencySymbol) ) {
        return originalText
      }
      let currencyAmount = originalText.match(regx);
      if (!currencyAmount) {
        return originalText;
      }

      currencyAmount = originalText.match(regx)[0];
      const originalParts = originalText.split(currencyAmount);

      return `${originalParts[0]}
      <sup>${window.theme.currentCurrencySymbol}</sup>
      ${slate.Currency.removeCurrencySymbol(slate.Currency.formatMoney(price, ShopifyCurrencyMoneyFormat))}${originalParts[1]}`
    }
    updateProductPrice(productCard, currentVariant) {
      //console.log('updateProductPrice', window.theme.moneyFormat, Currency.formatMoney(currentVariant.price, window.theme.moneyFormat))
      const pricingWrap = productCard.querySelector('.xgen-product-card__price-container');
      if( pricingWrap && currentVariant.price ) {
        let pricingHTML = `<p class="xgen-product-card__price xgen-text-[length:var(--price-size)] apply-font-body xgen-apply-font-body xgen-not-italic xgen-font-bold xgen-text-[var(--price-color)]">
          ${this.formatMoney(currentVariant.price)}
        </p>`

        if( currentVariant.compareAtPrice > currentVariant.price ) {
          pricingHTML = `<p class="xgen-product-card__compare-price xgen-text-[length:var(--compare-size)] apply-font-body xgen-apply-font-body xgen-not-italic xgen-font-normal xgen-line-through xgen-text-[var(--compare-color)]">
            ${this.formatMoney(currentVariant.compareAtPrice)}
          </p>` + pricingHTML

          pricingHTML += `<span class="product-per-off show-per-off-mobile show-per-off-desktop">(-${Math.round(((currentVariant.compareAtPrice - currentVariant.price) * 100) / currentVariant.compareAtPrice)}%)</span>`
        }

        pricingWrap.innerHTML = pricingHTML
      }
      pricingWrap.classList.add('visible')
    }

    handleProductCard(productCard, filteredProducts, repeated = false) {
      const _this = this;
      const variantIdOriginalInput = productCard.querySelector('input[name="id"].xgen-product-variant-id');
      if(variantIdOriginalInput && filteredProducts.length) {
        const variantId = variantIdOriginalInput.value;
        const form = productCard.querySelector('form[action*="cart/add"]');
        // hack required due to xgen updating its input to default variant id
        variantIdOriginalInput.name = 'variant_id';
        const variantIdInput = document.createElement('input');
        variantIdInput.name = 'id';
        variantIdInput.type = 'hidden';
        variantIdInput.value = variantId;
        form.appendChild(variantIdInput);
        const product = filteredProducts.find(product => product.variants.find(variant => variant.id === variantId));
        if( !product ) return;

        let currentVariant = product.variants ? product.variants.find(variant => variant.id === variantId) : null;
        //console.log('xgen product', product)

        const xGenOptions = productCard.querySelectorAll(
          '.xgen-product-card__options-selector button.xgen-block-option'
        );
        if (xGenOptions.length) {
          xGenOptions.forEach(function(xGenOption) {
            const xGenOptionName = xGenOption.innerText.trim();
            if (product) {
              const option = product.variants.find(variant => variant.title === xGenOptionName);
              if (option && option.available) {
                xGenOption.dataset.variantId = option.id;
                if (option.id === variantId) {
                  xGenOption.classList.add('active');
                }
                xGenOption.addEventListener('click', function(e) {
                  e.preventDefault();
                  variantIdInput.value = option.id;
                  xGenOptions.forEach(function(xGenOptionInner) {
                    xGenOptionInner.classList.remove('active');
                  });
                  xGenOption.classList.add('active');
                  currentVariant = option;
                  _this.updateProductPrice(productCard, currentVariant);
                });
              } else {
                xGenOption.disabled = true;
                xGenOption.classList.add('disabled');
              }
            }
          });
        }
        _this.updateProductPrice(productCard, currentVariant);
        form.addEventListener('submit', function(e) {
          e.preventDefault();
          addToCart(form);
          return false;
        });

        form.querySelector('button.xgen-product-card__add-to-cart').addEventListener('click', function(e) {
          e.preventDefault();
          addToCart(form);
          return false;
        });
      } else if(!repeated) {
        setTimeout(() => {
          _this.handleProductCard(productCard, filteredProducts, true);
        }, 100);
      }
    }

    async onReady() {
      const _this = this;
      const productCards = this.shadowRoot.querySelectorAll('.xgen-product-card');
      const variantIds = [];
      //console.log('productCards', productCards)
      Array.from(productCards).forEach(productCard => {
        if(productCard.querySelector('input[name="id"]')) variantIds.push(productCard.querySelector('input[name="id"]').value);
      });
      const allProducts = JSON.parse(sessionStorage.getItem(PRODUCTS_STORAGE_KEY) || '[]');
      let filteredProducts = allProducts.length
        ? allProducts.filter(product => {
            return (
              product.variants &&
              product.variants.find(variant => variant.id === variantIds.find(id => id === variant.id))
            );
          })
        : [];

      if (filteredProducts.length !== variantIds.length) {
        //console.log('fetching xgen products!', variantIds)
        const res = await fetch(`https://${window.Shopify.shop}/api/2025-10/graphql.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/graphql',
            'X-Shopify-Storefront-Access-Token': window.theme.storefrontAPIToken
          },
          body: `
            query getProducts @inContext(country: ${Shopify.country}) {
              ${variantIds
                .map(id => {
                  if( !id ) return '';
                  return `p_${id}: node(id: "gid://shopify/ProductVariant/${id}") {
                  id
                  ... on ProductVariant {
                    id
                    product {
                      id
                      variants(first: 250) {
                        edges {
                          node {
                            id
                            title
                            availableForSale
                            price {
                              amount
                            }
                            compareAtPrice {
                              amount
                            }
                          }
                        }
                      }
                    }
                  }
                }`;
                })
                .join('\n')}

            }
          `
        });
        const resData = await res.json();
        //console.log('resData', resData)
        try {
          filteredProducts = Object.keys(resData.data).map(key => {

            const product = resData.data[key].product;
            return {
              id: product.id.split('/').pop(),
              variants: product.variants.edges.map(variant => ({
                id: variant.node.id.split('/').pop(),
                title: variant.node.title,
                available: variant.node.availableForSale,
                price: variant.node.price ? variant.node.price.amount * 100 : null,
                compareAtPrice: variant.node.compareAtPrice ? variant.node.compareAtPrice.amount * 100 : null
                }))
              };

          });
        } catch (error) {
          console.log('Error parsing products', error);
        }
      }

      productCards.forEach((productCard) => {
        _this.handleProductCard(productCard, filteredProducts, false);
      });
    }
  }
  customElements.define('x-product-recommendations', window.CustomProductRecommendations);
}
